import { Capacitor } from '@capacitor/core';
import {
  PurchaseProvider
} from './purchase-provider.interface';
import {
  CapacitorPurchaseProvider
} from './capacitor-purchase-provider';
import {
  WebPurchaseProvider
} from './web-purchase-provider';

export function purchaseProviderFactory(
  capacitorProvider: CapacitorPurchaseProvider,
  webProvider: WebPurchaseProvider
): PurchaseProvider {
  const platform = Capacitor.getPlatform();
  if (platform === 'ios'
    || platform === 'android') {
    return capacitorProvider;
  }
  if (platform !== 'web') {
    console.warn(
      `PurchaseProviderFactory: Unknown `
      + `platform '${platform}'; defaulting `
      + `to WebPurchaseProvider`
    );
  }
  return webProvider;
}
